import { filterPredicateIsTruthy } from 'utility/Check/filterPredicateIsTruthy';

import { AttributesSearchParam, paramTruthyValue } from 'types/Search/params';

import { Attribute } from 'proto/Accommodation/Attributes';

export const attributeToParamMap: Record<
    Attribute,
    AttributesSearchParam | undefined
> = {
    [Attribute.ActionAndFun]: AttributesSearchParam.ActionAndFun,
    [Attribute.AdultsOnly]: AttributesSearchParam.AdultsOnly,
    [Attribute.Ayurveda]: AttributesSearchParam.Ayurveda,
    [Attribute.BabyCot]: AttributesSearchParam.BabyCot,
    [Attribute.BabySitting]: AttributesSearchParam.BabySitting,
    [Attribute.BeautyFarm]: AttributesSearchParam.BeautyFarm,
    [Attribute.BuggyRent]: AttributesSearchParam.BuggyRent,
    [Attribute.CentralLocation]: AttributesSearchParam.CentralLocation,
    [Attribute.CharmFlair]: AttributesSearchParam.CharmFlair,
    [Attribute.ChildFriendly]: AttributesSearchParam.ChildFriendly,
    [Attribute.ChildrensBuffet]: AttributesSearchParam.ChildrensBuffet,
    [Attribute.ChildrensPlayground]: AttributesSearchParam.ChildrensPlayground,
    [Attribute.ChildrensPlayroom]: AttributesSearchParam.ChildrensPlayroom,
    [Attribute.ChildrensPool]: AttributesSearchParam.ChildrensPool,
    [Attribute.CityBreaks]: AttributesSearchParam.CityBreaks,
    [Attribute.Club]: AttributesSearchParam.Club,
    [Attribute.Cosmetic]: AttributesSearchParam.Cosmetic,
    [Attribute.CulinaryDelights]: AttributesSearchParam.CulinaryDelights,
    [Attribute.Cycling]: AttributesSearchParam.Cycling,
    [Attribute.Deluxe]: AttributesSearchParam.Deluxe,
    [Attribute.DirectBeachAccess]: AttributesSearchParam.DirectBeachAccess,
    [Attribute.Diving]: AttributesSearchParam.Diving,
    [Attribute.FamilyHoliday]: AttributesSearchParam.FamilyHoliday,
    [Attribute.Fitness]: AttributesSearchParam.Fitness,
    [Attribute.FreeParking]: AttributesSearchParam.FreeParking,
    [Attribute.FreeWLAN]: AttributesSearchParam.FreeWLAN,
    [Attribute.GayHotel]: AttributesSearchParam.GayHotel,
    [Attribute.GentlySlopingSandyBeach]:
        AttributesSearchParam.GentlySlopingSandyBeach,
    [Attribute.GermanSpeakingEntertainmentForKids]:
        AttributesSearchParam.GermanSpeakingEntertainmentForKids,
    [Attribute.Golf]: AttributesSearchParam.Golf,
    [Attribute.GreatSportsOffer]: AttributesSearchParam.GreatSportsOffer,
    [Attribute.HandicappedAccessible]:
        AttributesSearchParam.HandicappedAccessible,
    [Attribute.HeatedPool]: AttributesSearchParam.HeatedPool,
    [Attribute.Hiking]: AttributesSearchParam.Hiking,
    [Attribute.HolidayForTwo]: AttributesSearchParam.HolidayForTwo,
    [Attribute.HorseRiding]: AttributesSearchParam.HorseRiding,
    [Attribute.HotelNearTheBeach]: AttributesSearchParam.HotelNearTheBeach,
    [Attribute.IndoorPool]: AttributesSearchParam.IndoorPool,
    [Attribute.Internet]: AttributesSearchParam.Internet,
    [Attribute.KidsDisco]: AttributesSearchParam.KidsDisco,
    [Attribute.LaundryService]: AttributesSearchParam.LaundryService,
    [Attribute.LonghaultJourney]: AttributesSearchParam.LonghaultJourney,
    [Attribute.Massages]: AttributesSearchParam.Massages,
    [Attribute.MaxiClub]: AttributesSearchParam.MaxiClub,
    [Attribute.MedicalService]: AttributesSearchParam.MedicalService,
    [Attribute.MiniClub]: AttributesSearchParam.MiniClub,
    [Attribute.NiceSmallFamilyRun]: AttributesSearchParam.NiceSmallFamilyRun,
    [Attribute.NonSmokingHotel]: AttributesSearchParam.NonSmokingHotel,
    [Attribute.NonSmokingRooms]: AttributesSearchParam.NonSmokingRooms,
    [Attribute.ParkingSpacesAvailable]:
        AttributesSearchParam.ParkingSpacesAvailable,
    [Attribute.PettingZoo]: AttributesSearchParam.PettingZoo,
    [Attribute.Pool]: AttributesSearchParam.Pool,
    [Attribute.RelaxationOffersForBodyAndSoul]:
        AttributesSearchParam.RelaxationOffersForBodyAndSoul,
    [Attribute.Restaurant]: AttributesSearchParam.Restaurant,
    [Attribute.Sailing]: AttributesSearchParam.Sailing,
    [Attribute.SandyBeach]: AttributesSearchParam.SandyBeach,
    [Attribute.Sauna]: AttributesSearchParam.Sauna,
    [Attribute.Singles]: AttributesSearchParam.Singles,
    [Attribute.SingleWithChild]: AttributesSearchParam.SingleWithChild,
    [Attribute.SoccerSchool]: AttributesSearchParam.SoccerSchool,
    [Attribute.SportOffersForChildren]:
        AttributesSearchParam.SportOffersForChildren,
    [Attribute.Squash]: AttributesSearchParam.Squash,
    [Attribute.Surfing]: AttributesSearchParam.Surfing,
    [Attribute.Kitesurfing]: AttributesSearchParam.Kitesurfing,
    [Attribute.SwimSchool]: AttributesSearchParam.SwimSchool,
    [Attribute.Tennis]: AttributesSearchParam.Tennis,
    [Attribute.Thalasso]: AttributesSearchParam.Thalasso,
    [Attribute.VacationAtMediterraneanSea]:
        AttributesSearchParam.VacationAtMediterraneanSea,
    [Attribute.VacationAtNorthOrBalticSea]:
        AttributesSearchParam.VacationAtNorthOrBalticSea,
    [Attribute.VacationInAustria]: AttributesSearchParam.VacationInAustria,
    [Attribute.VacationInGermany]: AttributesSearchParam.VacationInGermany,
    [Attribute.VacationInTheMountains]:
        AttributesSearchParam.VacationInTheMountains,
    [Attribute.WaterSlide]: AttributesSearchParam.WaterSlide,
    [Attribute.WaterSports]: AttributesSearchParam.WaterSports,
    [Attribute.Wellness]: AttributesSearchParam.Wellness,
    [Attribute.Windsurfing]: AttributesSearchParam.Windsurfing,
    [Attribute.WinterSports]: AttributesSearchParam.WinterSports,
    [Attribute.Wingfoiling]: AttributesSearchParam.Wingfoiling,
    [Attribute.BabyEquipment]: AttributesSearchParam.BabyEquipment,
    [Attribute.PetsAllowed]: AttributesSearchParam.PetsAllowed,
    [Attribute.QuietLocation]: AttributesSearchParam.QuietLocation,
    [Attribute.HoneymoonTravel]: AttributesSearchParam.HoneymoonTravel,
    // unknown attributes for url
    [Attribute.GolfOld]: undefined,
    [Attribute.GolfOld2]: undefined,
    [Attribute.ThemeParks]: undefined,
    [Attribute.LegoLandDenmark]: undefined,
    [Attribute.LegoLandGermany]: undefined,
    [Attribute.DisneyLand]: undefined,
    [Attribute.HansaPark]: undefined,
    [Attribute.EuropaPark]: undefined,
    [Attribute.PhantasiaLand]: undefined,
    [Attribute.HeidePark]: undefined,
    [Attribute.MoviePark]: undefined,
    [Attribute.Transfer]: undefined,
};

export const paramToAttributeMap: Record<AttributesSearchParam, Attribute> =
    Object.fromEntries(
        Object.entries(attributeToParamMap)
            .filter(filterPredicateIsTruthy)
            .map(([key, value]) => [value, key])
    );

export const convertAttributesListToUrlParams = (
    attributesList: Set<Attribute>
) => {
    const urlParams = new URLSearchParams();
    if (attributesList.size) {
        attributesList.forEach((attribute) => {
            const attributeParam = attributeToParamMap[attribute];
            if (attributeParam) {
                urlParams.append(attributeParam, paramTruthyValue);
            }
        });
    }

    return urlParams;
};

export const convertParamsToAttributesList = (
    urlParams: URLSearchParams
): Set<Attribute> => {
    const possibleParams = Object.values(AttributesSearchParam);
    const attributesList = possibleParams
        .map((param) => {
            if (
                urlParams.has(param) &&
                urlParams.get(param) === paramTruthyValue
            ) {
                return paramToAttributeMap[param];
            }
        })
        .filter(filterPredicateIsTruthy);

    return new Set(attributesList);
};
